import { Root as l, CollapsibleTrigger as o, CollapsibleContent as e } from "../../modules/index.es37.js";
const t = l, i = o, C = e;
export {
  t as Collapsible,
  C as CollapsibleContent,
  i as CollapsibleTrigger
};
//# sourceMappingURL=Collapsible.es.js.map
